import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const orderRepo = OrderRepositoryImpl.getInstance();

interface RemoveProductFromBasketMutationProps {
  readonly itemId: string;
  readonly orderId: string;
  readonly serviceId: string;
}

const useRemoveProductFromBasket = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: ({ itemId, orderId, serviceId }: RemoveProductFromBasketMutationProps) => {
        return orderRepo.removeItem({ auth, itemId, orderId, serviceId, apiUrl });
      },
    },
    queryClient,
  );

  const removeProductFromBasket = useCallback(
    (payload: RemoveProductFromBasketMutationProps, onSuccess: () => void, onError: (error: unknown) => void) => {
      mutation.mutate(payload, { onSuccess, onError });
    },
    [mutation],
  );

  return removeProductFromBasket;
};

export { useRemoveProductFromBasket };
